import { render, staticRenderFns } from "./MessageThreads.vue?vue&type=template&id=4b5fea88"
import script from "./MessageThreads.vue?vue&type=script&lang=js"
export * from "./MessageThreads.vue?vue&type=script&lang=js"
import style0 from "./MessageThreads.vue?vue&type=style&index=0&id=4b5fea88&prod&lang=scss"
import style1 from "./MessageThreads.vue?vue&type=style&index=1&id=4b5fea88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports